import React from 'react';
import { mockLienRegister } from '../../../services/mockData';

const LienRegister = () => (
  <div className="fade-in">
    <div className="page-header">
      <div className="breadcrumb">Registers <span>/ Lien Register</span></div>
      <h2>Lien Register</h2>
    </div>

    <div className="card">
      <div className="card-header">
        <span className="card-title">Lien Report</span>
        <button className="btn btn-warning btn-sm">🖨️ Print</button>
      </div>

      <div className="report-header" style={{ marginBottom: '16px' }}>
        <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
        <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
        <p style={{ fontWeight: '700', marginTop: '6px' }}>Lien Register 2025-2026 On dated: 2026-02-02</p>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Unit No.</th>
              <th>Name of the Member</th>
              <th>Lending Bankers Name Address</th>
              <th>Date</th>
              <th>Remark</th>
              <th>Closer Date</th>
            </tr>
          </thead>
          <tbody>
            {mockLienRegister.map((l, i) => (
              <tr key={i}>
                <td><span className="badge badge-primary">{l.unit}</span></td>
                <td style={{ fontWeight: '600' }}>{l.memberName}</td>
                <td>{l.lendingBank || '—'}</td>
                <td>{l.date || '—'}</td>
                <td>{l.remark || '—'}</td>
                <td>
                  {l.closerDate ? (
                    <span className="badge badge-success">{l.closerDate}</span>
                  ) : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default LienRegister;
